import React from "react";
import { RevealHeading, StaggerReveal } from "./Motion";
import { Check, Minus } from "lucide-react";
import { ScribbleCircle } from "./Decorations";

const COMPETITORS = ["Audo", "BeyondWords", "ElevenLabs", "Google TTS"];
const ROWS = [
    ["Native Bengali pronunciation", true, false, "partial", "partial"],
    ["Pricing in BDT", true, false, false, false],
    ["WordPress 1-click plugin", true, true, false, false],
    ["Embed via 1-line script", true, true, false, false],
    ["West Bengal dialect support", true, false, false, false],
    ["Audio ad revenue share", true, false, false, false],
    ["Listener analytics built-in", true, true, false, false],
    ["Cost per article (~3 min)", "$0.02", "$0.18", "$0.30", "$0.16"],
];

const Cell = ({ v, win }) => {
    if (v === true) return <span className="inline-flex items-center justify-center w-7 h-7 rounded-full" style={{ background: win ? "#FF5B3E" : "#0A0A0A" }}><Check size={14} className="text-white" strokeWidth={3}/></span>;
    if (v === false) return <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-cream-300"><Minus size={14} className="text-ink-muted"/></span>;
    if (v === "partial") return <span className="text-[12px] font-medium text-ink-muted">Partial</span>;
    return <span className={`text-[13px] font-mono font-semibold ${win ? "text-coral" : "text-ink-muted"}`}>{v}</span>;
};

export const Comparison = () => {
    return (
        <section className="relative py-24 lg:py-32 overflow-hidden">
            <ScribbleCircle color="#3D5BFF" className="absolute -top-6 left-[5%] w-24 h-24 opacity-50"/>
            <div className="relative mx-auto max-w-[1240px] px-5 sm:px-8">
                <div className="max-w-[820px] mb-12 lg:mb-16">
                    <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-coral mb-5">vs the world</p>
                    <RevealHeading as="h2" className="h-display text-[44px] sm:text-[60px] lg:text-[80px] text-ink">
                        Why not just use a global tool?
                    </RevealHeading>
                </div>

                <div className="overflow-x-auto -mx-5 sm:mx-0">
                    <div className="min-w-[760px] px-5 sm:px-0">
                        <StaggerReveal stagger={0.05}>
                            <div data-stagger className="grid grid-cols-[2fr_1.1fr_1fr_1fr_1fr] gap-2 px-6 py-5 bg-ink-pill text-cream-100 rounded-t-3xl">
                                <span className="text-[12px] uppercase tracking-[0.22em] font-semibold text-cream-100/60">Feature</span>
                                {COMPETITORS.map((c, i) => (
                                    <span key={i} className={`text-center text-[13px] font-semibold ${i === 0 ? "text-coral" : "text-cream-100/80"}`}>
                                        {c}
                                    </span>
                                ))}
                            </div>
                            <div className="bg-white border-x border-cream-300">
                                {ROWS.map((row, i) => (
                                    <div data-stagger key={i} className={`grid grid-cols-[2fr_1.1fr_1fr_1fr_1fr] gap-2 px-6 py-4 items-center ${i % 2 === 0 ? "bg-cream-50" : "bg-white"} border-b border-cream-300 last:border-b-0`}>
                                        <span className="text-[14px] sm:text-[15px] font-medium text-ink">{row[0]}</span>
                                        {row.slice(1).map((v, j) => (
                                            <span key={j} className="flex justify-center"><Cell v={v} win={j === 0}/></span>
                                        ))}
                                    </div>
                                ))}
                            </div>
                            <div data-stagger className="grid grid-cols-[2fr_1.1fr_1fr_1fr_1fr] gap-2 px-6 py-4 bg-coral text-white rounded-b-3xl">
                                <span className="text-[12px] uppercase tracking-[0.22em] font-semibold">Best for Bengali</span>
                                <span className="text-center text-[13px] font-bold">★ Winner</span>
                                <span/><span/><span/>
                            </div>
                        </StaggerReveal>
                    </div>
                </div>
            </div>
        </section>
    );
};
